<template>
    <div class="image-slider">
        <ssr-carousel
            v-model="index"
            class="slider-list"
            ref="slider"
            :loop="true"
            :slides-per-page="prop_max"
            :paginate-by-slide="true"
            :autoplay-delay="prop_loop"
            :show-arrows="false"
            gutter="0"
            >
            <div
                class="image item"
                v-for="(image, idx) in lst"
                :key="idx"
                >
                <img
                    :src="image.src"
                    :alt="image.alt"
                    @click="pswpView(image)"
                    />
                <div class="cmt">{{image.alt}}</div>
            </div>
        </ssr-carousel>
        <button
            type="button"
            class="nav back"
            @click="back"
            >
            <i class="material-icons">arrow_back_ios</i>
        </button>
        <button
            type="button" 
            class="nav next"
            @click="next"
            >
            <i class="material-icons">arrow_forward_ios</i>
        </button>
    </div>
</template>

<script>
    //components
    import SsrCarousel from 'vue-ssr-carousel';
    import 'vue-ssr-carousel/index.css';

    //functions
    import { posiveRemainder } from '../modules/utils.js';

    export default {
        name: 'ImageSlider',
        props: ['data-source', 'loop', 'max', 'pswp-opened'],
        data() {
            return {
                index: 0
            };
        },
        computed: {
            lst() {
                return Array.isArray(this.dataSource) ? this.dataSource : [];
            },
            prop_max() {
                const max = Number(this.max);
                return max > 0 ? max : 5;
            },
            prop_loop() {
                const loop = Number(this.loop);
                return loop > 0 && !this.pswpOpened ? (loop / 1000) : 0;
            }
        },
        methods: {
            gotoIfNeeded(idx) {
                const length = this.lst.length;
                idx = posiveRemainder(idx, length);
                let step_left = posiveRemainder(this.index - idx, length);
                let step_right = (idx - this.index - this.prop_max + 1) % length;
                if (step_right <= -this.prop_max) {
                    step_right += length;
                }
                if (step_left <= 0 || step_right <= 0) {
                    return;
                }
                if (step_left > 0 && step_left < step_right) {
                    this.index = posiveRemainder(this.index - step_left, length);
                } else if (step_right > 0 && step_right < step_left) {
                    this.index = posiveRemainder(this.index + step_right, length);
                }
            },
            pswpView(image) {
                this.$emit('pswp-view', image);
            },
            onImageChanged(img) {
                const idx = this.lst.findIndex(image => image.id === img.id);
                idx >= 0 && this.gotoIfNeeded(idx);
            },
            back() {
                this.$refs.slider.back();
            },
            next() {
                this.$refs.slider.next();
            }
        },
        components: {
            SsrCarousel
        }
    }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .image-slider{
        background: #000;
        position: relative;
    }

    .nav{
        position: absolute;
        top: 0;
        bottom: 0;
        background-color: rgb(0 0 0 / 40%);
        border: none;
        color: #fff;
    }
    .nav.back{
        left: 0;
    }
    .nav.next{
        right: 0;
    }

    .slider-list{
        height: 100%;
    }

    .image{
        position: relative;
        /*height: 100%;*/

        height: 200px;
    }
    .image img{
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    .image .cmt{
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        background:rgba(0,0,0,0.7);
        color: #fff;
        font-size: 0.8em;
        padding: 5px 0.8em;
    }


    @media screen and (max-width: 768px){
        .image{
            height: 80px;
        }
        .image .cmt{
            display: none;
        }
    }
</style>
